export function budgetSummaryModel(total, budget) {
  const spent = Number(total)
  const budgetNum = Number(budget)
  const spentOk = Number.isFinite(spent)
  const hasBudget = Number.isFinite(budgetNum) && budgetNum > 0

  if (!hasBudget) {
    return {
      hasBudget: false,
      budget: 0,
      spent: spentOk ? spent : 0,
      percent: null,
      fillPercent: 0,
      remaining: null,
      over: false,
      overAmount: 0,
      status: 'none',
    }
  }

  const safeSpent = spentOk ? spent : 0
  const remaining = budgetNum - safeSpent
  const percent = (safeSpent / budgetNum) * 100
  const over = remaining < 0
  const status = over ? 'over' : percent >= 80 ? 'warning' : 'ok'

  return {
    hasBudget: true,
    budget: budgetNum,
    spent: safeSpent,
    percent,
    fillPercent: Math.min(100, Math.max(0, percent)),
    remaining,
    over,
    overAmount: over ? Math.abs(remaining) : 0,
    status,
  }
}
